import { render, staticRenderFns } from "./checkTable.vue?vue&type=template&id=30c8c80f&scoped=true&"
import script from "./checkTable.vue?vue&type=script&lang=js&"
export * from "./checkTable.vue?vue&type=script&lang=js&"
import style0 from "./checkTable.vue?vue&type=style&index=0&id=30c8c80f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c8c80f",
  null
  
)

export default component.exports